export const convertToVariantsArrayForExternalLibrary = (variants) => {
    return variants.map((variant) => {
        if (variant === 'italic') return '400i'
        else if (variant === 'regular') return '400'
        else if (variant.includes('italic')) return variant.replace('italic', 'i')
        return variant
    })
}
